<template>
  <div class="list" ref="wrapper">
    <div>
      <div class="top">
        <i class="iconfont icon-sousuo1"></i>
        <input type="text" placeholder="查找企业" />
      </div>
      <div class="list1">
        <ul>
          <li class="all" @click="all" :style="{color:clickType == 0?'#333333':'#666666'}">全部</li>
          <li
            class="apply"
            @click="alreadyApply"
            :style="{color:clickType == 1?'#333333':'#666666'}"
          >已报名</li>
          <li
            class="no_apply"
            @click="noApply"
            :style="{color:clickType == 2?'#333333':'#666666'}"
          >未报名</li>
          <li
            class="binding_apply"
            @click="bindApply"
            :style="{color:clickType == 3?'#333333':'#666666'}"
          >绑定申请</li>
        </ul>
      </div>
      <!-- 城市列表 -->
      <!-- <div class="area" v-for="(item,key) in cities" :key="key" :ref="key">
        <div class="title border-topbottom">{{key}}</div>
        <div class="button-list">
          <div class="button-wrapper" v-for="innerItem in item" :key="innerItem.id">
            <div class="button">{{innerItem.name}}</div>
          </div>
        </div>
      </div>-->
      <div
        class="student_list"
        v-for="(item,i) in cities"
        :key="i"
        :ref="item.chart"
        v-show="clickType == 0"
      >
        <div class="first_name">{{item.chart}}</div>
        <div class="student">
          <div class="item" v-for="(res,index) in item.data" :key="index">
            <div class="left">
              <img src="../assets/image/userIcon.jpg" alt />
              <span class="name">{{res.realname}}</span>
            </div>
            <div class="right" @click="relieveBind(res.id)">
              <img src="../assets/image/cancelBind.png" alt />
              <span class="status">解除绑定</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bind_apply" v-show="clickType == 3" v-for="(item,i) in allStudent" :key="i">
        <div class="left">
          <img src="../assets/image/userIcon.jpg" alt />
          <span class="student_name">{{item.realname}}</span>
        </div>
        <div class="right">
          <button class="agreeBind">同意绑定</button>
        </div>
      </div>
    </div>
    <!-- 弹出层 -->
    <transition name="fade">
      <div class="toast" v-show="showToast">
        <span class="letter">{{this.letter}}</span>
      </div>
    </transition>
  </div>
</template>
<script>
import Bscroll from "better-scroll";
import eventBus from "../model/eventBus";
export default {
  name: "tList",
  props: {
    cities: Array,
    hotCities: Array
  },
  data() {
    return {
      letter: "",
      showToast: false,
      clickType: 0,
      allStudent:[],
    };
  },
  watch: {
    letter() {
      if (this.letter) {
        const elment = this.$refs[this.letter][0];
        this.scroll.scrollToElement(elment);
        this.changeToast();
      }
    }
  },
  created() {
  },
  methods: {
    changeToast() {
      this.showToast = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.showToast = false;
      }, 500);
    },
    // li标签的点击(全部)
    all() {
      this.clickType = 0;
      this.$emit("func", 0);
    },
    // li标签的点击(已报名)
    alreadyApply() {
      this.clickType = 1;
      this.$emit("func", 1);
      this.getBindStudent(1);
    },
    // li标签的点击(未报名)
    noApply() {
      this.clickType = 2;
      this.$emit("func", 1);
    },
    // li标签的点击(绑定申请)
    bindApply() {
      this.clickType = 3;
      this.$emit("func", 1);
      this.getBindStudent(3);
    },
    // 获取绑定的学员
    getBindStudent(type) {
      this.$http
        .getBindStudent({
          type: type
        })
        .then(res => {
          if (res.status == 1) {
            this.allStudent = res.data;
          }
        });
    },
    // 解除绑定
    relieveBind(id) {
      this.$http
        .confirmUnbindStudent({
          student_id: id
        })
        .then(res => {
          if (res.status == 1) {
            this.$hide
              .alert({
                message: res.msg
              })
              .then(() => {
                // 调用父组件的方法
                this.getBindStudent(0);
              });
          } else {
            this.$hide.alert({
              message: res.msg
            });
          }
        });
    }
  },
  mounted() {
    eventBus.$on("change", letter => {
      this.letter = letter;
    });
    this.scroll = new Bscroll(this.$refs.wrapper, {
      click: true
    });
  }
};
</script>
<style lang="less" scoped>
.list {
  position: absolute;
  overflow: hidden;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f5f5f5;
  .title {
    line-height: 27px;
    padding-left: 10px;
    background: #eee;
  }
  .button-list {
    padding: 5px 30px 5px 5px;
    overflow: hidden;
    .button-wrapper {
      float: left;
      width: 25%;
      .button {
        margin: 5px;
        padding: 5px;
        font-size: 12px;
        border: 1px solid #ccc;
        border-radius: 3px;
        text-align: center;
      }
    }
  }
  .toast {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    width: 50px;
    height: 50px;
    background: #ed4e5e;
    border-radius: 50%;
    text-align: center;
    transition: all 0.5s;
    &.fade-enter {
      opacity: 0;
    }

    &.fade-leave,
    &.fade-enter-active {
      opacity: 1;
    }

    &.fade-leave-active {
      opacity: 0;
    }

    .letter {
      line-height: 50px;
      font-size: 16px;
      font-weight: 700;
      color: #eee;
    }
  }

  .top {
    width: 100%;
    height: 51px;
    background-color: #fff;
    position: relative;
    padding-bottom: 5px;
    input {
      width: 90%;
      background-color: #f0f0f0;
      text-align: center;
      color: #999999;
      font-size: 14px;
      border: none;
      height: 34px;
      line-height: 34px;
      border-radius: 17px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .iconfont {
      position: absolute;
      top: 50%;
      left: 40%;
      transform: translate(-50%, -50%);
      z-index: 10;
      color: #999999;
    }
  }
  .list1 {
    width: 100%;
    height: 40px;
    ul {
      width: 100%;
      height: 40px;
      background-color: #fff;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      padding: 10px 0;
      box-sizing: border-box;
      li {
        width: 24%;
        height: 100%;
        float: left;
        font-size: 17px;
        color: #666666;
        line-height: 20px;
        text-align: center;
        border-right: 1px solid #ddd;
      }
    }
  }
}
.student_list {
  width: 100%;
  background-color: #fff;
  .first_name {
    font-size: 20px;
    color: #666666;
    width: 100%;
    height: 28px;
    line-height: 28px;
    background-color: #f5f5f5;
    padding-left: 23px;
    box-sizing: border-box;
  }
  .student {
    width: 100%;
    .item {
      width: 100%;
      padding: 5px 25px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ddd;
      .left {
        img {
          width: 45px;
          height: 45px;
          vertical-align: middle;
        }
        .name {
          font-size: 20px;
          color: #333333;
          vertical-align: middle;
          margin-left: 16px;
        }
      }
      .right {
        .status {
          font-size: 17px;
          color: #63b0f7;
          margin-right: 20px;
          vertical-align: middle;
        }
        img {
          width: 17px;
          height: 18px;
          vertical-align: middle;
          margin-right: 3px;
        }
      }
    }
  }
}
.bind_apply {
  width: 100%;
  background-color: #fff;
  height: 75px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  .left {
    margin-left: 20px;
    img {
      width: 40px;
      height: 40px;
      vertical-align: middle;
    }
    .student_name {
      font-size: 16px;
      vertical-align: middle;
      margin-left: 15px;
    }
  }
  .right {
    margin-right: 20px;
    .agreeBind {
      float: right;
      width: 61px;
      height: 26px;
      background-color: #0e88f7;
      color: #fff;
      border-radius: 30px;
      border: none;
      font-size: 12px;
    }
  }
}
</style>


